import { Route } from '@/routes/enum';
import { ResponseSuccess } from '@/typings/api';

export enum GIN_BOUNDARY_DATABASE_USERS_ASSIGNMENTS_API_KEY {
  GET = 'GET/GIN_BOUNDARY_DATABASE_USERS_ASSIGNMENTS',
  // [PLOP ANCHOR] apisKeyEnum
}

export type AssignedPermissionRoute =
  | Route.VENDOR
  | Route.RAW_MATERIAL
  | Route.RAW_MATERIAL_TRANSPORTATION
  | Route.WASTE_TRANSPORTATION
  | Route.PRODUCT_LINE
  | Route.DISTRIBUTION_TRANSPORTATION
  | Route.SCENARIOS_CONFIGURATION;

export enum AssignedPermission {
  PRODUCT_LINE = 'PRODUCT_LINE',
  VENDOR = 'VENDOR',
  RAW_MATERIAL = 'RAW_MATERIAL',
  RAW_MATERIAL_TRANSPORTATION = 'TRANSPORTATION',
  WASTE_TRANSPORTATION = 'OPERATION_WASTE_TRANSPORTATION',
  DISTRIBUTION_TRANSPORTATION = 'DISTRIBUTION',
  SCENARIOS_CONFIGURATION = 'SCENARIO',
  EMPLOYEE = 'EMPLOYEE',
  EMPLOYEE_COMMUTING = 'EMPLOYEE_COMMUTING',
}

export interface GetGinBoundaryDatabaseUsersAssignmentsParams {
  query: { boundaryId: string };
}
export interface GetGinBoundaryDatabaseUsersAssignmentsResData {
  assignments: AssignedPermission[];
}
export type GetGinBoundaryDatabaseUsersAssignmentsRes = ResponseSuccess<GetGinBoundaryDatabaseUsersAssignmentsResData>;
